import { MenuSource } from '@client/graphql/types/graphql.ts';
import { useMenuList } from '@client/page/management/menu/menu-list/logic/use-menu-list.ts';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import PrimaryButton from '@packages/ui/button/primary-button.tsx';
import SecondaryButton from '@packages/ui/button/secondary-button.tsx';
import CardTableContent from '@packages/ui/card/card-content-table.tsx';
import CardHeader from '@packages/ui/card/card-header.tsx';
import Card from '@packages/ui/card/card.tsx';
import TableHeaderColumn from '@packages/ui/table/table-header-column.tsx';
import TableRowColumn from '@packages/ui/table/table-row-cell.tsx';
import TableRow from '@packages/ui/table/table-row.tsx';
import { TableCellAlignment } from '@packages/ui/table/table-type';
import Table from '@packages/ui/table/table.tsx';
import { useTranslate } from '@tolgee/react';
import { capitalize } from 'lodash';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import { ContentLayout, PrimaryContent } from 'ui/src/content-layout';

export default function MenuList() {
  const navigate = useNavigate();
  const { t } = useTranslate();

  const { loading, error, data, refetch } = useMenuList([MenuSource.Restaurant, MenuSource.DigitalMenu]);

  return (
    <ContentLayout>
      <Helmet>
        <title>{t('menu.menu-list.helmet.title')}</title>
        <meta name="description" content={t('menu.menu-list.helmet.description')} />
      </Helmet>
      <PrimaryContent>
        <Card>
          <CardHeader title={t('menu.menu-list.header')}>
            {/* Create button */}
            <PrimaryButton
              onClick={() => {
                navigate('create');
              }}
              data-testid="list-create-button"
            >
              {t('menu.menu-list.button.create', 'Create')}
            </PrimaryButton>

            {/* Refresh button */}
            <SecondaryButton
              onClick={() => {
                refetch().catch((e) => void e);
              }}
            >
              <ArrowPathIcon className="w-4" />
            </SecondaryButton>
          </CardHeader>

          <CardTableContent>
            <Table
              loading={loading}
              error={error?.message}
              data={data?.menus_v2 ?? []}
              build={(menu) => {
                return (
                  <TableRow key={menu.id}>
                    <TableRowColumn>
                      <Link to={menu.id}>{menu.title}</Link>
                    </TableRowColumn>

                    <TableRowColumn alignment={TableCellAlignment.Right}>
                      <span className="text-gray-500 italic">
                        {t(
                          `menu-list.source.${menu.menuSource}`,
                          capitalize(menu.menuSource.split('_').join(' ').toString()),
                        )}
                      </span>
                    </TableRowColumn>
                  </TableRow>
                );
              }}
            >
              <TableHeaderColumn>{t('common.table-header-column.name')}</TableHeaderColumn>

              <TableHeaderColumn alignment={TableCellAlignment.Right}>
                {t('common.table-header-column.menu-source', 'Menu Origin')}
              </TableHeaderColumn>
            </Table>
          </CardTableContent>
        </Card>

        {/* Hide INH-145 */}
        {/* <MenuPreviewSetup /> */}
      </PrimaryContent>
    </ContentLayout>
  );
}
